import classes from "../questions.module.css";
import {ReactComponent as DELETE} from "../../images/trash_red.svg";
import {
    handleAddAnswer,
    handleDeleteAnswer,
    handleUpdateAnswer
} from "../../utils/questionUpdate";
import {
    GRADE_SCHEMA,
    MC_ANSWER_LENGTH,
} from "../../utils/constants";
import React, {Fragment} from "react";
import { useTranslation } from "react-i18next";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as PlusIcon} from "../../images/plus.svg";

export default function FITBAnswerNew({
                                          gradeSchema,
                                          questions,
                                          setQuestions,
                                          selectedQuestion,
                                          editorState,
                                          setEditorState,
                                          compositeDecorator,
}) {
    const { t } = useTranslation();

    const {queTitle, correctAnswers={}, serialNo, weightage} = selectedQuestion;
    const gradeEnable = gradeSchema !== GRADE_SCHEMA.UNGRADED.key && !!weightage;


    if (!gradeEnable || !correctAnswers || Object.keys(correctAnswers).length === 0) {
        return <></>;
    }

    return (
        <>
            <span style={{fontWeight: "600", marginTop: 5}}>{t("poll.correctAnswersText")}</span>
            {Object.keys(correctAnswers).map((key, index) => (
                <Fragment key={index}>
                    <div  className={classes.FITBCorrectAnswerContainer}>
                        <span className={classes.FITBBlankNameBox}>
                            <span style={{flex: 1, minWidth: 0, overflowWrap: "break-word", textAlign: "center"}}>
                                {key}
                            </span>
                        </span>
                        <div className={classes.FITBAnswerInputList}>
                            {correctAnswers[key].map((value, idx) => (
                                <div key={idx} className={classes.FITBAnswerInputBox}>
                                    <div className={classes.FITBAnswerInputWrapper}>
                                        <input
                                            placeholder={t('questionBuilder.enterCorrectResponseText')}
                                            value={value}
                                            maxLength={100}
                                            onChange={(e) => {
                                                handleUpdateAnswer(key, idx, e.target.value, correctAnswers, serialNo - 1, questions, setQuestions)
                                            }}
                                        />
                                        <span className={classes.FITBAnswerCharacterCountBox}>
                                            {value.length}/{MC_ANSWER_LENGTH}
                                        </span>
                                    </div>

                                    <span
                                        tabIndex={0}
                                        role={"button"}
                                        aria-label={t("questionBuilder.deleteAnswerLower")}
                                        className={classes.FITBDeleteAnswerBox}
                                        onClick={() => handleDeleteAnswer(key, idx, correctAnswers, serialNo - 1,
                                            questions, setQuestions, editorState, setEditorState, compositeDecorator
                                        )}
                                    >
                                    <DELETE/>
                                </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <YuJaButton
                        title={t('poll.previewText')}
                        onClick={() => handleAddAnswer(key, correctAnswers, serialNo - 1, questions, setQuestions)}
                        style={{
                            height: 35,
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            whiteSpace: "nowrap",
                            alignSelf: "end"
                        }}
                    >
                        <PlusIcon style={{width: 15, height: 15, marginRight: 2}}/>{t('questionBuilder.addAnotherAnswerText')}
                    </YuJaButton>
                </Fragment>


            ))}
        </>
    );
}